import React from "react"

/** @deprecated Use icons from icons-v2-generated instead. */
export interface MacOSIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export function MacOSIcon({ className, color = 'white', ...props }: MacOSIconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path d="M12.2131 8.41846C12.1971 6.7312 13.5884 5.92054 13.651 5.88193C12.8678 4.73511 11.6515 4.57748 11.2182 4.55979C10.1831 4.45363 9.1978 5.171 8.67145 5.171C8.14509 5.171 7.3347 4.57427 6.47616 4.59196C5.34642 4.60804 4.30494 5.24981 3.72242 6.26314C2.55096 8.29943 3.42394 11.3233 4.56812 12.9784C5.12818 13.7875 5.79254 14.6994 6.66873 14.6657C7.51282 14.6319 7.83056 14.1188 8.84797 14.1188C9.86538 14.1188 10.1526 14.6657 11.0433 14.6496C11.9499 14.6319 12.5244 13.8228 13.0797 13.0106C13.7184 12.0696 13.9831 11.1609 13.9992 11.1126C13.9783 11.1046 12.2324 10.4338 12.2131 8.41846Z" fill={color} />
      <path d="M10.5393 3.46284C11.0047 2.89827 11.3176 2.11496 11.2326 1.33325C10.5634 1.3606 9.75299 1.7804 9.27317 2.34497C8.8431 2.84359 8.46598 3.64138 8.56869 4.407C9.31168 4.4649 10.0755 4.02579 10.5393 3.46284Z" fill={color} />
    </svg>
  )
}